/*
 * Meztli · ficha de producto («Lo esencial», snippets/mz-esencial.liquid).
 *
 * El enlace «¿Te falta un dato? Te lo damos por WhatsApp» lleva el SKU de la variante. product-info.js de Dawn
 * solo refresca precio, SKU, inventario y volumen al cambiar de variante; aquí se copia el contacto que el
 * servidor ya pintó para la variante nueva (el HTML que llega en el evento variantChange), sin tocar
 * product-info.js. Solo si el HTML es del MISMO producto: el quick add de otro producto publica el mismo evento
 * con el id de sección de la plantilla.
 */
(() => {
  if (window.mzFichaContacto || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.mzFichaContacto = true;

  const productoDe = (el) => el.closest('product-info')?.dataset.productId;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    const id = `MzContacto-${data.sectionId}`;
    const fuente = data.html.getElementById(id);
    const destino = document.getElementById(id);
    if (!fuente || !destino || productoDe(fuente) !== productoDe(destino)) return;
    destino.innerHTML = fuente.innerHTML;
  });
})();
